// removed by extract-text-webpack-plugin
module.exports = {"ContactSideBar":"ContactSideBar---1_TJw","hideContactSidebarButton":"hideContactSidebarButton---1-C8l"};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/components/conversation/ContactSideBar/style.styl
// module id = APMr
// module chunks = 89